export var setClarityUserTags = function (userId, roleId) {
    if (typeof window.clarity === "function") {
        window.clarity("set", "user_id", userId);
        window.clarity("set", "role_id", roleId);
    }
};
export var setClarityTag = function (key, value) {
    if (typeof window.clarity === "function") {
        window.clarity("set", key, value);
    }
};
